export function parseDomNewSiteCities(value: unknown): string[] {
  const list: unknown[] | null = toArray(value);
  if (!list) {
    return [];
  }

  const keys: string[] = [];

  for (const item of list) {
    const key: string | null = toFeatureKey(item);
    if (key === null) {
      return [];
    }

    keys.push(key);
  }

  return keys;
}

function toArray(value: unknown): unknown[] | null {
  if (Array.isArray(value)) {
    return value;
  }

  // GB иногда отдаёт JSON-фичу строкой
  if (typeof value === 'string') {
    const trimmed: string = value.trim();
    if (!trimmed.startsWith('[')) {
      return null;
    }

    try {
      const parsed: unknown = JSON.parse(trimmed);
      return Array.isArray(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }

  return null;
}

function toFeatureKey(value: unknown): string | null {
  if (typeof value === 'string') {
    const trimmed: string = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }

  // В GB UI числовой alias часто сохраняется как number (1545), не "1545"
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }

  return null;
}
